module.exports = __webpack_public_path__ + "VIPH13.png?3256c7f444307dc789c8823cd090a1e9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH13.png
// module id = 85
// module chunks = 0